<app-shared-dialog
  [title]="'quotations_and_orders.enrich_company_emails.title' | translate"
  [options]="{
    size: 'medium',
    confirmText: (data?.deferSave
      ? 'quotations_and_orders.enrich_company_emails.add'
      : 'quotations_and_orders.enrich_company_emails.save') | translate,
    cancelText: 'common.cancel' | translate,
    confirmLoading: isSaving,
    confirmDisabled: isSaving || selectedCount === 0
  }"
  (confirm)="save()"
  (cancel)="close()">

  <div class="enrich-emails">
    <p class="enrich-emails__description">
      {{ 'quotations_and_orders.enrich_company_emails.suffix_desc' | translate }}
    </p>

    <div class="enrich-emails__list">
      <div class="enrich-emails__row" *ngFor="let row of rows">
        <span class="enrich-emails__email" [title]="row.email">{{ row.email }}</span>
        <mat-slide-toggle
          [(ngModel)]="row.enabled"
          color="primary"
          [disabled]="isSaving"
          [attr.aria-label]="'quotations_and_orders.enrich_company_emails.toggle_label' | translate: { email: row.email }">
        </mat-slide-toggle>
      </div>
    </div>

    <p class="enrich-emails__description">
      {{ 'quotations_and_orders.enrich_company_emails.prefix_desc' | translate }} {{ data?.companyName }}
    </p>

    <div class="enrich-emails__location" *ngIf="selectableLocations.length">
      <label class="enrich-emails__location-label">
        {{ 'quotations_and_orders.enrich_company_emails.shipping_location' | translate }}
      </label>
      <div class="standard-input">
        <select
          class="enrich-emails__location-select"
          [(ngModel)]="selectedLocationId"
          (ngModelChange)="onLocationChange()"
          [disabled]="isSaving">
          <option [ngValue]="null">
            {{ 'quotations_and_orders.enrich_company_emails.no_location' | translate }}
          </option>
          <option *ngFor="let location of selectableLocations" [ngValue]="location.id">
            {{ locationLabel(location) }}
          </option>
        </select>
      </div>
    </div>

    <p class="enrich-emails__disclaimer">
      {{ 'quotations_and_orders.enrich_company_emails.disclaimer' | translate }}
    </p>
  </div>
</app-shared-dialog>
